import { ErrorMessageDetail } from '@shared/models/common.model';
import { v4 as uuidV4 } from 'uuid';

// from angular2-draggable/lib/models/resize-event
export interface ISize {
  width: number;
  height: number;
}

// from angular2-draggable/lib/models/resize-event
export interface IResizeEvent {
  host: any;
  handle: any;
  size: ISize;
  position: {
    top: number;
    left: number;
  };
  direction: {
    n: boolean;
    s: boolean;
    w: boolean;
    e: boolean;
  };
}

export enum Language {
  th = 'th',
  en = 'en',
}

export function toTitleCase(str: string): string {
  return str.replace(/\w\S*/g, (txt) => {
    return txt.charAt(0).toUpperCase() + txt.substr(1);
  });
}

export function buildErrorHTMLMessage(
  error: ErrorMessageDetail,
  wrap?: boolean,
): string {
  if (Array.isArray(error)) {
    const list = error
      .map((errorItem) => {
        return typeof errorItem === 'string'
          ? `<li>${errorItem}</li>`
          : buildErrorHTMLMessage(errorItem);
      })
      .join('');
    return `<ul class="mb-0 pl-3">${list}</ul>`;
  }

  if (typeof error === 'string') {
    return wrap
      ? `<ul class="mb-0 pl-3"><li>${error}</li></ul>`
      : error;
  }

  return Object.entries(error)
    .map(([key, value]) => {
      return `
        <ul class="mb-0 pl-3">
          <li>${toTitleCase(key)}
            ${buildErrorHTMLMessage(value, true)}
          </li>
        </ul>
      `;
    })
    .join('');
}

export function buildFullName(
  firstname: string,
  lastname: string,
): string {
  if (firstname && lastname) {
    return `${firstname} ${lastname}`;
  } else {
    return firstname || lastname;
  }
}

export function generateUUID(): string {
  return uuidV4();
}

export function getPreViewAttachmentHeader(module: any): string {
  if (module == 'comment') {
    return 'MEMOS.MEMO-DETAIL.Comment';
  } else if (module == 'Attachment') {
    return 'COMMON.Attachments';
  } else if (module == 'Reference') {
    return 'MEMOS.MEMO-DETAIL.References';
  } else if (module == 'News Feed') {
    return 'SIDEBAR.NEWS-FEED';
  } else {
    return '';
  }
}
